const initState = {
  _id: "",
  first_name: "",
  last_name: "",
  email: "",
  role: "",
  status: "",
  company_ids: [],
  can_invite_accountants: null,
  can_invite_staff: null,
};

export const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "REGISTER": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "LOGOUT":
      return {};
    default:
      return state;
  }
};